import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface TopBarProps {
  title?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  showMenu?: boolean
}

const pageTitles: Record<string, string> = {
  '/admin/dashboard': 'KEGIATAN ISWARA JATIM',
  '/admin/laporan': 'Laporan',
  '/admin/pimpinan': 'Pimpinan',
  '/admin/settings': 'Profil',
  '/admin/stadion': 'Dashboard Stadion',
  '/admin/program-kerja': 'Program Kerja',
}

// Halaman utama yang back button nya ke login
const mainPages = ['/admin/dashboard', '/admin/stadion', '/admin/laporan', '/admin/settings', '/admin/program-kerja']

export default function TopBar({ leftIcon, rightIcon, showMenu }: TopBarProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const logout = useAuthStore((s) => s.logout)

  const title = pageTitles[location.pathname] || 'ISWARA PW Jawa Timur'

  const isMainPage = mainPages.some(page => location.pathname === page || location.pathname.startsWith(page + '/'))

  const handleBack = () => {
    if (isMainPage) {
      logout()
      navigate('/login', { replace: true })
    } else {
      navigate(-1)
    }
  }

  // Menu button untuk kembali ke iswarajatim.com
  const handleMenu = () => {
    window.location.href = 'https://iswarajatim.com'
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary shadow-topbar">
      <div className="max-w-2xl mx-auto h-14 flex items-center justify-between px-4">
        <div className="w-10 flex items-center justify-start">
          {leftIcon || (
            <button
              onClick={handleBack}
              className="text-white/80 hover:text-white transition-colors p-1"
              title={isMainPage ? 'Logout' : 'Kembali'}
            >
              {isMainPage ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              )}
            </button>
          )}
        </div>

        <h1 className="text-white font-bold text-base truncate">{title}</h1>

        <div className="w-10 flex items-center justify-end">
          {rightIcon || (showMenu ? (
            <button
              onClick={handleMenu}
              className="w-9 h-9 bg-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg transition-shadow"
              title="Menu"
            >
              <svg className="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
              </svg>
            </button>
          ) : null)}
        </div>
      </div>
    </header>
  )
}
